import { ENGLISH_NAV } from "./nav-consts-en"
import { SPANISH_NAV } from "./nav-const-es-mx"

const userLanguage = navigator.language || navigator.userLanguage

const getNavigationNav = () => {
    if (userLanguage.startsWith("es")) return SPANISH_NAV
    else if (userLanguage.startsWith("en")) return ENGLISH_NAV
    else return ENGLISH_NAV
}

export const NavigationNavItmes = getNavigationNav()

export const paths = {
    dashboard: "/",
    inventory: "/inventory",
    management: "/management",
    planning: "/planning",
    reviewPlan: "/review-plan",
    calendarview: "/calendar-view",
    discardPlan: "/discard",
    accessorialManagement: "/chargeManagement",
    generalPlacement: "/general-placement",
}
